export const SET_OPTION = 'pickuptime.SET_OPTION';
export const CALC_TIMES = 'pickuptime.CALC_TIMES';
export const SET_SERVER_TIME = 'pickuptime.SET_SERVER_TIME';


// WEBPACK FOOTER //
// ./src/types/pickUpTime.js